<template>
    <v-scale-transition>

        <div v-if="visible">

            <div class="d-flex">
                <v-checkbox v-model="emailCheckboxModel"
                            hide-details
                            :background-color="backgroundColor"
                            :color="color"
                            class="ma-0 mr-2 mb-1 align-self-center"
                            @change="emailCheckboxChanged"/>
                <div v-html="acceptEmailLabel" class="align-self-center">
                </div>
            </div>

            <div class="d-flex mt-3">
                <v-checkbox v-model="termsCheckboxModel"
                            hide-details
                            :background-color="backgroundColor"
                            :color="color"
                            class="ma-0 mr-2 mb-1 align-self-center"
                            @change="termsCheckboxChanged"/>
                <div v-html="acceptTermsLabel" class="align-self-center">
                </div>
            </div>
        </div>

    </v-scale-transition>
</template>

<script>

import policyLinkHelperMixin from "@/components/mixins/policyLinkHelperMixin.js";
import colorMixin from "@/components/mixins/colorMixin.js";

export default {

    name: "AcceptConditionCheckboxes",

    mixins: [policyLinkHelperMixin, colorMixin],

    props: {
        subPanelTranslations: {
            type: Object,
            required: true,
        },
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        backgroundColor: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: false,
            default: "primary",
        },
        subPanelId: {
            type: Number,
            required: true,
        },
        localeCode: {
            type: String,
            required: true,
        },
        termsAndConditionsUrl:  {
            type: String | null,
            required: false,
        },

        privacyPolicyUrl:  {
            type: String | null,
            required: false,
        },

        cookiePolicyUrl:  {
            type: String | null,
            required: false,
        },
    },

    computed: {
        acceptTermsLabel() {
            return this.replaceVariables(
                this.subPanelTranslations.survey_accept_terms_checkbox_label,
                this.getFontClasses(this.backgroundColor),
                this.subPanelId,
                this.localeCode,
                this.termsAndConditionsUrl,
                this.privacyPolicyUrl,
                this.cookiePolicyUrl
            );
        },
        acceptEmailLabel() {
            return this.replaceVariables(
                this.subPanelTranslations.survey_accept_email_checkbox_label,
                this.getFontClasses(this.backgroundColor),
                this.subPanelId,
                this.localeCode,
                this.termsAndConditionsUrl,
                this.privacyPolicyUrl,
                this.cookiePolicyUrl
            );
        }
    },

    data() {
        return {
            termsCheckboxModel: false,
            emailCheckboxModel: false,
        }
    },

    methods: {
        termsCheckboxChanged() {
            this.emit();
        },

        emailCheckboxChanged() {
            this.emit();
        },

        emit() {
            this.$emit('accepted', this.termsCheckboxModel && this.emailCheckboxModel);
        }
    }
}
</script>
